import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/main/shared/services/data.service';

@Component({
  selector: 'app-metwise-alerts-sidebar',
  templateUrl: './metwise-alerts-sidebar.component.html',
  styleUrls: ['./metwise-alerts-sidebar.component.scss']
})
export class MetwiseAlertsSidebarComponent implements OnInit, OnDestroy {

  queryParams: any = {};
  private destroy$ = new Subject<void>();
  isInitialLoad: boolean = false;
  sessionStorage: any = { params: {} };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private utils: UtilsService,
    private dataService: DataService
  ) { }

  ngOnInit() {
    this.isInitialLoad = true;
    this.utils.selectedParams.pipe(takeUntil(this.destroy$)).subscribe((params: any) => {
      let sessionStorageSelectedParams: any = sessionStorage.getItem('params');
      if (Object.keys(params).length > 0) {
        this.queryParams = params;
      } else {
        this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
        this.sessionStorage.params = { ...this.queryParams };
        if (Object.keys(this.queryParams).length) {
          this.utils.setSelectedParams(this.queryParams);
        }
      }
    });
    if (this.isInitialLoad && !Object.keys(this.sessionStorage.params).length) {
      this.requestSelectedFilterParams();
    }
    this.isInitialLoad = false;
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    if (!this.isInitialLoad) {
      currentUrlParams = this.queryParams;
    }
    if (this.isInitialLoad) {
      currentUrlParams['component'] = 'METWISEALERTS';
      let metaInfo: any = localStorage.getItem('metaInfo');
      let metaInfoJson: any = !isNullOrUndefined(metaInfo) ? JSON.parse(metaInfo) : {};
      let finalMetaInfo = metaInfoJson;
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'Admin';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      currentUrlParams['dashboardType'] = 'gis';
      const userLocationConfig = this.dataService.formQuerParamsVariables(
        finalMetaInfo.userDetailsJson.data.location,
        finalMetaInfo.userDetailsJson.data.locType
      );
      const currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
      currentUrlParams['pUUID'] = currentLocations[1];
      currentUrlParams['locName'] = currentLocations[0];
      currentUrlParams['locType'] = userLocationConfig.types.pType;
      currentUrlParams['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
      currentUrlParams['location'] = userLocationConfig.locationInfo.location;
      currentUrlParams['forecastLength'] = 'liveAlerts';
      currentUrlParams['horizon'] = '-3Hr'
    }
    this.utils.setSelectedParams(currentUrlParams);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
